import styled, { css } from "styled-components";

import { StyledToken } from "./Token.styles";
import { TOKEN_MARGIN_RIGHT } from "./Tokenizer.utils";

interface ITokenizerStyleProps {
    $isWrappable?: boolean;
    $isWrapped?: boolean;
}

export const StyledTokenizerOuterWrapper = styled.div<ITokenizerStyleProps>`
    display: flex;
    flex: 0 1 auto;
    align-items: center;

    margin-top: -1px;
    margin-right: ${`${TOKEN_MARGIN_RIGHT}px;`}

    position: relative;

    max-width: ${props => `calc(100% - ${TOKEN_MARGIN_RIGHT}px)`};
`;

export const StyledTokenizer = styled.div<ITokenizerStyleProps>`
    display: flex;
    flex-direction: ${props => props.$isWrapped ? "column" : "row"};
    //width: fit-content;
    position: relative;
    min-height: 22px; // empty tokenizer to be rendered correctly with just after tokens text filled (it's absolutely positioned, so we need to keep horizontal space for it)

    flex-wrap: ${props => props.$isWrappable ? "wrap" : "nowrap"};

    ${StyledToken}:not(:last-child) {
        margin-right: ${`${TOKEN_MARGIN_RIGHT}px;`}
    }

    ${StyledToken} {
        // prevent initial flickering by hiding all tokens completely by default
        visibility: ${props => props.$isWrappable ? "visible" : "hidden"};
    }

    ${props => props.$isWrappable && css`
        flex-wrap: wrap;
        // compensate for the token margin
        margin-bottom: -4px;

        ${StyledToken} {
            display: block;
            margin-bottom: 4px;
            width: fit-content;
        }
    `}
`;

export const AfterTokensText = styled.span`
    position: absolute;
`;